<div class="modal-header">
  <h5 class="modal-title">{{heading}} </h5>
  <a><i class="fas fa-times closebtn" (click)="closeModal('close')"></i></a>

</div>

<div class="new-reason" style="display: none;">
  <div class="container" style="height: 500px; overflow: auto;margin-top: 10px;">
    <div class="row">
      <div class="col-md-6">
        <div>
          <label>{{'ChooseAllApplies' | translateOrgSpecific}}</label>
        </div>
        <div>
          <div *ngFor="let list of caseList; index as i" class="case-list">
            <div class="card card-category" style=" cursor: pointer;margin-bottom: 10px;"
              [ngClass]="{'highlight':!list.isHighlight,'noHighlight':list.isHighlight}" (click)="cardClick(list)"
              name="list.issue_category_id">
              <div style="margin-bottom: 10px;margin-top: 15px;">
                <div style="float:left;margin-right:10px;">
                  <i class="fa fa-check-circle" aria-hidden="true" style="font-size:25px; margin-left: 8px;"
                    [ngClass]="{'icon-color-heighlight':!list.isHighlight,'icon-color':list.isHighlight}"></i>
                </div>
                <div style="margin-left: 50px;">
                  <label>{{list.issueCategoryName}}</label>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="is_other_case" style="padding-left: 15px;padding-bottom: 10px; ">
            <input type="text" name="otherCase" class="form-control" style="height:40px; width:86% "
              [(ngModel)]="otherCase">

          </div>

        </div>

      </div>

      <div class="col-md-6">
        <div>
          <label>{{'CountyQuestionInCasePage' | translateOrgSpecific}}</label>
          <div style="width: 85%;">
            <label>{{'County' | translateOrgSpecific}}</label>
            <ejs-dropdownlist required #cou="ngModel" name="cou" [dataSource]='caseCountyList'
              [fields]="{text: 'name', value: 'coutyId'}" [(ngModel)]="county"
              [class.is-invalid]="cou.invalid && cou.touched" placeholder="Select"></ejs-dropdownlist>
          </div>
        </div>
        <div style="margin-top: 15px;color:#dd0707;font-weight: 700;">
          <label> {{'Important' | translateOrgSpecific}}</label>
          <label>{{'ForEmergency' | translateOrgSpecific}}</label>
        </div>
      </div>


    </div>
  </div>


  <div class="modal-footer">
    <div>
      <button class="btn btn-sm btn-apportis-tertiary "
        [disabled]="selectedCases.length == 0 || !county ||(selectedCases.length >0 && is_other_case  && !otherCase) "
        type="submit" (click)="onSubmit() " *ngIf="is_participant ||( no_questions && is_casemanager )">{{'Submit' |
        translateOrgSpecific}}</button>
      <button class="btn btn-sm btn-apportis-tertiary "
        [disabled]="selectedCases.length == 0 || !county || (selectedCases.length >0 && is_other_case  && !otherCase)"
        type="submit" (click)="onSubmit() " *ngIf="is_casemanager && !no_questions" style="width: 90px;">{{'Next' |
        translateOrgSpecific}}</button>
    </div>

  </div>
</div>

<!-- Questions -->
<div *ngFor="let ans of newCaseQuestions; let last=last ">
  <div class="case-question-div" style="display: none">
    <div class="container" style="height: 500px; overflow: auto;">

      <div class="issue-cgy">
        {{ans.issueCategoryName}}

      </div>


      <label class="question-label"> {{ans.questionText}}</label>


      <app-option-control [options]="ans.answerChoice" [type]="ans.questiontypeCd" [answeroptionid]=ans.answer
        (RadioChange)="onChange($event)">
        <!-- (RadioChange)="onChange($event)" -->
      </app-option-control>
      {{last ? callFunction(ans) : '' }}

      <div style="padding-left:30px; padding-bottom: 10px; padding-right: 30px;" *ngIf="is_others_choice">
        <input type="text" name="othersReason" class="form-control" [(ngModel)]="othersReason"
          [ngModelOptions]="{standalone: true}">
      </div>

    </div>

  </div>
</div>
<div class="question-footer" style="display: none">
  <div class="modal-footer">
    <div>
      <button class="btn btn-sm btn-apportis-tertiary " type="submit" style="width: 90px;" (click)="prev()"
        *ngIf="is_prev_but">{{'Previous' | translateOrgSpecific}}</button>
      <button class="btn btn-sm btn-apportis-tertiary prev-but-gap" type="submit" *ngIf="!is_last_que"
        [disabled]="((!is_answered && !prev_clicked) || (is_others_choice  && !othersReason))" style="width: 90px;"
        (click)="next()">{{'Next' | translateOrgSpecific}}</button>

      <button class="btn btn-sm btn-apportis-tertiary prev-but-gap   " type="submit" *ngIf="is_last_que"
        [disabled]="((!is_answered )|| (is_others_choice  && !othersReason) )" style="width: 90px;"
        (click)="submit()">{{'Submit' | translateOrgSpecific}}</button>
    </div>

  </div>
</div>

<!-- clientList -->
<div class="client-list" style="display: none;">
  <div class="container" style="height: 500px; overflow: auto;">

    <div class="row " style="padding-bottom: 2%; padding-left: 10px; padding-top: 10px;">
      <div class="col-md-5" style="font-size: 16px;">
        <span>{{'ChooseClient' | translateOrgSpecific}}</span>
      </div>


    </div>
    <div class="row">
      <div class="col-md-12">
        <div class=" search-box-align">
          <div class="input-icons">
            <i class="fas fa-search" style="padding:7px;"></i>
            <input class="search-txt-box form-control  " type="text" [(ngModel)]="searchText" style="width:100%"
              autocomplete="true">
          </div>


        </div>
      </div>

    </div>
    <hr>
    <div class="modal-body" style="padding: 0rem 1rem 1rem 1rem !important;">
      <div class="card-data d-flex">
        <div *ngFor="let ele of patients | filter:searchText" class="case-list">
          <div>

            <div class="card card-client " style=" cursor: pointer;height: 75px;;"
              [ngClass]="{'highlight':!ele.isHighlight,'noHighlight':ele.isHighlight}" (click)="ClientCardClick(ele)"
              name="ele.case_id">
              <div class="row" style=" cursor: pointer;">
                <div class="col-md-12" style="padding-top:10px">
                  <div style="float: left;">
                    <img *ngIf="ele.profileImage"
                      style="height:35px;margin-top: 15px;margin-left: 10px;margin-right: 5px; border-radius: 16px;width: 35px;vertical-align: top;"
                      class="img-circle" [src]="ele.profileImage">
                    <i *ngIf="!ele.profileImage" class="fas fa-user-circle img-circle "
                      style="font-size:25px;margin: 15px 0px 20px 10px;"></i>
                  </div>
                  <div style="margin-left: 60px;" *ngIf="ele.age">
                    <label style="font-size: 16px;">{{ele.displayName}}</label> <br>
                    <div *ngIf="ele.age">Age: <label style="font-size: 16px;">{{ele.age}}</label> </div>
                  </div>
                  <div style="margin-left: 60px;margin-top: 15px;margin-bottom: 20px;" *ngIf="!ele.age">
                    <label style="font-size: 16px;">{{ele.displayName}}</label> <br>
                  </div>
                </div>

              </div>
            </div>

          </div>

          <div *ngIf=" patients.length == 0" class="case-list">
            {{'Noclient' | translateOrgSpecific}}

          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div>
      <button (click)="closeModal('Modal Closed')" class="btn btn-sm btn-apportis-tertiary btn-cancel"
        type="submit">{{'Cancel' | translateOrgSpecific}}</button>

      <button class="btn btn-sm btn-apportis-tertiary" (click)="clientSelect()" type="submit" style="width: 6.5rem;"
        [disabled]="participantId == 0">
        {{'Next' | translateOrgSpecific}} </button>
    </div>
  </div>

</div>